export default __webpack_public_path__ + "static/media/mobile_5.e4af88b7.png";